import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties"; //@ts-check

import React from 'react';
import RepositoryPicker from '../../../core/RepositoryPicker';
import absolute from '../../../utils/pathUtil/absolute';
import stripDesignTrunkFromPath from '../../../utils/pathUtil/stripDesignTrunkFromPath';
import addDesignTrunk from '../../../utils/pathUtil/addDesignTrunk';
import relative from '../../../utils/pathUtil/relative';
import FileFormInput from '../File';
/**
 * @param {import('./types').FormInputRepositoryPickerAcceptedValueType} pathAndWorkspace
 * @param {import('./types').FormInputRepositoryPickerProps["baseUrl"]} basePath
 * @returns {import('./types').FormInputRepositoryPickerValueType}
 */

var decode = function decode(pathAndWorkspace, basePath) {
  if (pathAndWorkspace === null) {
    return {
      workspace: null,
      path: null
    };
  } else if (typeof pathAndWorkspace === 'string') {
    if (pathAndWorkspace.indexOf('/') > -1) {
      var segments = pathAndWorkspace.split('/');
      var workspace = segments.shift();
      var path = addDesignTrunk(segments.join('/'));
      return {
        workspace: workspace,
        path: absolute(path, basePath)
      };
    }
  } else if (typeof pathAndWorkspace === 'object') {
    var _workspace = pathAndWorkspace.workspace || null;

    var _path = pathAndWorkspace.path || null;

    if (!_path) {
      return {
        workspace: _workspace,
        path: null
      };
    }

    return {
      workspace: _workspace,
      path: absolute(_path, basePath)
    };
  }

  return {
    workspace: null,
    path: null
  };
};
/**
 * @param {import('./types').FormInputRepositoryPickerValueType} value
 * @param {import('./types').FormInputRepositoryPickerProps["baseUrl"]} basePath
 */


var encode = function encode(_ref, basePath) {
  var workspace = _ref.workspace,
      path = _ref.path;
  if (!workspace) return '';
  if (!path) return '';
  if (!basePath) return workspace + '/' + stripDesignTrunkFromPath(path);
  return relative(path, basePath);
};
/**
 * @param {import('./types').FormInputRepositoryPickerProps} props
 */


var RepositoryPickerFormInput = function RepositoryPickerFormInput(_ref2) {
  var value = _ref2.value,
      _onChange = _ref2.onChange,
      baseUrl = _ref2.baseUrl,
      placeholder = _ref2.placeholder,
      name = _ref2.name,
      label = _ref2.label,
      variant = _ref2.variant,
      disabled = _ref2.disabled,
      textFieldProps = _ref2.textFieldProps,
      rest = _objectWithoutProperties(_ref2, ["value", "onChange", "baseUrl", "placeholder", "name", "label", "variant", "disabled", "textFieldProps"]);

  var basePath = rest.lockWorkspace ? baseUrl : null;

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      open = _React$useState2[0],
      toggle = _React$useState2[1];

  var closePicker = function closePicker() {
    return toggle(false);
  };

  var openPicker = function openPicker() {
    if (!disabled) toggle(true);
  };

  var _decode = decode(value, basePath),
      workspace = _decode.workspace,
      path = _decode.path;

  var prettyPath = encode({
    workspace: workspace,
    path: path
  }, basePath);
  var defaultSelection = path ? [path] : undefined;
  return React.createElement(React.Fragment, null, React.createElement(FileFormInput, Object.assign({
    value: prettyPath,
    placeholder: placeholder,
    name: name,
    label: label,
    variant: variant,
    disabled: disabled,
    onClick: openPicker
  }, textFieldProps)), open && React.createElement(RepositoryPicker, Object.assign({
    onChange: function onChange(selection) {
      if (selection.length) {
        var _decode2 = decode(selection[0], basePath),
            _path2 = _decode2.path,
            _workspace2 = _decode2.workspace;

        _onChange({
          path: relative(_path2, basePath),
          workspace: _workspace2
        });
      } else {
        _onChange({
          path: null,
          workspace: null
        });
      }

      closePicker();
    },
    workspace: workspace,
    path: path,
    defaultSelection: defaultSelection,
    onClose: closePicker
  }, rest)));
};
/**@type {Partial<import('./types').FormInputRepositoryPickerProps>} */


RepositoryPickerFormInput.defaultProps = {
  placeholder: 'No file chosen',
  baseUrl: null,
  variant: 'standard'
};
export default RepositoryPickerFormInput;